<template>
    <transition name="fade" mode="out-in">
        <div class="cookie-banner shadow" v-if="!cookie" :class="darkMode ? '' : 'bg-info'">
        <p>Wir verwenden <span class="mr-1">🍪</span> Cookies, um Dein Nutzererlebnis zu verbessern</p>
        <b-row class="m-0">
            <b-col cols="12" sm="8" >
            <p class="custom-nav hover-3 mt-2" @click="$router.push('/datenschutz')"> <u>Datenschutz</u> </p>
            </b-col>
            <b-col cols="12" sm="4"> 
            <b-button class="btn" variant="dark" :class="darkMode ? 'text-white' : 'text-info'" @click="acceptCookies()"> Okay 👍 </b-button>
            </b-col>        
        </b-row>
        </div>
        <!-- <message v-else/> -->
    </transition>
</template>

<script>
// import Message from './Message'
export default {
    name: 'Cookie-Banner',
    components: {
        // Message
    },
    data () {
        return {
            cookie: true,
        }
    },
    mounted(){
       if(!localStorage.getItem('cookie')){
           this.cookie = false
       }
    },
    methods: {
        acceptCookies(){
            this.cookie = true
            localStorage.setItem('cookie', 'accepted')
        }
    },
    computed: {
        darkMode(){
            return this.$store.getters.darkMode
        }
    }
}
</script>

<style>
 .cookie-banner {
    transition: all .3s ease;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 30px;
    max-width: 500px;
    min-width: 250px;
    padding: 30px;
    position: fixed;
    bottom: 25px;
    left: 25px;
    z-index: 3000;
    width: 70%;
    background-color: white;
    color: black;
  }
</style>